module.exports = __webpack_public_path__ + "static/img/ios_ms.abc0edab.png";